'use strict';
const angular = require('angular');

export class weatherForecastWidgetComponent {

  constructor() {
    'ngInject';
  }

  $onInit() {
   this.unit = this.unit || 'f';
  }
}

export default angular.module('conduuApp.weatherForecastWidget', [])
  .component('weatherForecastWidget', {
    template: `<weather-forecast location="{{$ctrl.location}}" unit="{{$ctrl.unit}}"></weather-forecast>`,
    bindings: {
     location: '@',
     unit: '@'
    },
    controller: weatherForecastWidgetComponent
  })
  .name;



// WEBPACK FOOTER //
// ./client/components/sidebar/weather-forecast-widget/weather-forecast-widget.component.js